<div #grid class="grid-container">
  <ag-grid-angular #filtersetsGrid
    class="{{ agTheme }}"
    [gridOptions]="gridOptions"
  ></ag-grid-angular>
</div>


